module.exports = __webpack_public_path__ + "assets/HKNova-SemiBold.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-SemiBold.eot
// module id = 127
// module chunks = 0